import type { MapEventBus } from "../../core/MapEventBus";

export class AircraftSelection {
  private selectedTarget = new Set<string>();
  private listeners = new Set<() => void>();

  constructor(private eventBus: MapEventBus) {
    this.setupListeners();
  }

  private setupListeners() {
    this.eventBus.on("aircraft:clicked", ({ track_id, properties }) => {
      console.log("properties", properties);
      this.toggle(track_id);
    });
  }

  private toggle(track_id: string) {
    if (this.selectedTarget.has(track_id)) {
      this.deselect(track_id);
    } else {
      this.select(track_id);
    }
  }

  private select(track_id: string) {
    this.selectedTarget.add(track_id);
    console.log("[AircraftSelection] Selected:", track_id);

    // FIX: Notify the manager instantly so it can flip the GPU state switch
    this.eventBus.emit("aircraft:selected", { track_id });

    this.notifySelectionChanged();
  }

  private deselect(track_id: string) {
    this.selectedTarget.delete(track_id);
    console.log("[AircraftSelection] Deselected:", track_id);

    // FIX: Notify the manager instantly so it can flip the GPU state switch
    this.eventBus.emit("aircraft:deselected", { track_id });

    this.notifySelectionChanged();
  }

  private emitChange() {
    this.listeners.forEach((cb) => cb());
  }

  subscribe = (callback: () => void) => {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  };

  getSnapshot = () => {
    return Array.from(this.selectedTarget);
  };

  private notifySelectionChanged() {
    this.eventBus.emit("aircraft:selection-changed", {
      selectedTargets: this.getSelected() ?? [],
    });

    this.emitChange();
  }

  // Public API
  getSelected(): string[] | null {
    return Array.from(this.selectedTarget.values());
  }

  isSelected(track_id: string): boolean {
    return this.selectedTarget.has(track_id);
  }

  // Programmatic control
  selectAircraft(track_id: string) {
    if (!this.selectedTarget.has(track_id)) {
      this.select(track_id);
      // FIX: Removed redundant notifySelectionChanged() call (handled inside select)
    }
  }

  deselectAircraft(track_id: string) {
    if (this.selectedTarget.has(track_id)) {
      this.deselect(track_id);
      // FIX: Removed redundant notifySelectionChanged() call (handled inside deselect)
    }
  }

  clearSelection() {
    if (this.selectedTarget.size === 0) return;

    // Notify removal for everything currently selected before clearing
    for (const track_id of this.selectedTarget) {
      this.eventBus.emit("aircraft:deselected", { track_id });
    }

    this.selectedTarget.clear();
    this.notifySelectionChanged();
  }

  toggleAircraft(track_id: string) {
    this.toggle(track_id);
  }

  destroy() {
    this.selectedTarget.clear();
    this.listeners.clear();
  }
}
